"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Configurator;

var _paper = _interopRequireDefault(require("paper"));

var _react = _interopRequireWildcard(require("react"));

var _draw = _interopRequireDefault(require("../utils/draw"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Configurator(_ref) {
  var _canvasRef$current, _canvasRef$current2;

  var input = _ref.input,
      watermarkUrl = _ref.watermarkUrl;
  var canvasRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var canvas = canvasRef.current;

    _paper.default.setup(canvas);
  }, [canvasRef.current]);
  (0, _react.useEffect)(function () {
    var canvasWidth = canvasRef.current.offsetWidth;
    var canvasHeight = canvasRef.current.offsetHeight;

    _paper.default.project.activeLayer.removeChildren();

    _paper.default.view.draw();

    (0, _draw.default)(input, {
      canvasWidth: canvasWidth,
      canvasHeight: canvasHeight,
      watermarkUrl: watermarkUrl
    });
  }, [input, watermarkUrl]);
  return /*#__PURE__*/_react.default.createElement("canvas", {
    ref: canvasRef,
    id: "canvas",
    width: (_canvasRef$current = canvasRef.current) === null || _canvasRef$current === void 0 ? void 0 : _canvasRef$current.offsetWidth,
    height: (_canvasRef$current2 = canvasRef.current) === null || _canvasRef$current2 === void 0 ? void 0 : _canvasRef$current2.offsetHeight,
    style: {
      width: "100%",
      height: "100%"
    }
  });
}